import { styled } from '@material-ui/core';

import Button from '@/components/Button';

const Illustration = styled('img')({
  display: 'block',
  margin: '0 auto',
  paddingTop: 32,
  width: 206,
});

const CircularIllustrationWrapper = styled('div')({
  width: 206,
  height: 206,
  borderRadius: '50%',
  overflow: 'hidden',
  margin: '0 auto',
  marginTop: 32,
});

const CircularIllustration = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
});

const ContentWrapper = styled('div')({
  textAlign: 'center',
  paddingTop: 32,
});

const Title = styled('h3')({
  color: '#163258',
  textAlign: 'center',
  fontFamily: '"GT Walsheim", sans-serif',
  fontSize: 24,
  fontWeight: 700,
  lineHeight: '135%',
  letterSpacing: -0.48,
  margin: 0,
});

const Subtitle = styled('p')({
  color: '#163258',
  textAlign: 'center',
  fontFamily: '"GT Walsheim", sans-serif',
  fontSize: 18,
  fontWeight: 400,
  lineHeight: '135%',
  marginTop: 8,
  marginBottom: 32,
});

const StyledButton = styled(Button)({
  backgroundColor: '#111',
  color: '#FFF',
  textAlign: 'center',
  fontFamily: '"GT Walsheim", sans-serif',
  fontSize: 18,
  fontWeight: 500,
  lineHeight: '135%',
  '&:hover': {
    backgroundColor: '#333',
  },
});

export default {
  Illustration,
  CircularIllustrationWrapper,
  CircularIllustration,
  ContentWrapper,
  Title,
  Subtitle,
  StyledButton,
};
